var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",on:{"click":_vm.handleBtnClicked}},[_c('div',{staticClass:"btn-bg"}),_c('div',{staticClass:"btn-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }